module.exports = __webpack_public_path__ + "img/pdfLogo.2afde345.svg";